module.exports = __webpack_public_path__ + "img/rss_feed.1785242e.svg";